import { mdiHome, mdiLogout, mdiMenu, mdiMenuDown, mdiMenuUp } from "@mdi/js";
import Icon from "@mdi/react";
import { Button, Drawer, Menu } from "antd";
import React, { useEffect, useState } from "react";
import type { MenuProps } from 'antd';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";
import UserApi from "../../api-services/user-api.service";
import { SIGNIN_URL } from "../../utils/helpers";

type MenuItem = Required<MenuProps>['items'][number];


const items: MenuItem[] = [
  {
    key: 'web',
    label: <Link to="/web"> <span className="nav-menu-home-label"> <Icon path={mdiHome} size="25px" /> <span>Home</span> </span> </Link>
  },
  {
    key: 'series-tour',
    label: <span>Series Tour <Icon path={mdiMenuDown} size="20px" /></span>,
    children: [
      {
        key: 'gd-classics',
        label: <Link to="/web/series-tour/gd-classics"> Classic </Link>
      },
      {
        key: 'gd-indepth',
        label: <Link to="/web/series-tour/gd-indepth"> In Depth </Link>
      },
      {
        key: 'the-signature-tours',
        label: <Link to="https://www.thesignaturetours.com" target="_blank" rel="noopener noreferrer"> The Signature Tours </Link>
      },
      {
        key: 'fs-holidays',
        label: <Link to="https://fsholidays.my" target="_blank" rel="noopener noreferrer"> FS Holidays </Link>
      }
    ]
  },
  {
    key: 'cruises',
    label: <span>Cruises <Icon path={mdiMenuDown} size="20px" /></span>,
    children:[
      {
        key: 'world-cruises',
        label: <Link to="/web/posts/world"> World Cruises </Link>
      },
      {
        key: 'fly-cruises',
        label: <Link to="/web/posts/fly"> Fly Cruise </Link>
      },
    ]
  },
  {
    key: 'ground',
    label: <Link to="/web/posts/trip"> Ground </Link>
  },
  {
    key: 'gd-flight',
    label: <span>Flight <Icon path={mdiMenuDown} size="20px" /></span>,
    children: [
      {
        key: 'gd-flight-about-us',
        label: <Link to="/web/gd-flight-about-us"> About Us </Link>
      },
      {
        key: 'gd-flight-airlines',
        label: <Link to="/web/posts/flight"> Airlines </Link>
      },
      {
        key: 'gd-flight-contact-agent',
        label: <Link to="/web/gd-flight-agents"> Contact Agents </Link>
      },
    ]
  },
  {
    key: 'corporate',
    label: <span>Corporate <Icon path={mdiMenuDown} size="20px" /></span>,
    children: [
      {
        key: 'corporate-mice',
        label: <Link to="/web/corporate/mice"> MICE </Link>
      },
      {
        key: 'corporate-business-travel',
        label: <Link to="/web/corporate/business-travel">Business Travel </Link>
      },

      {
        key: 'corporate-gd-warrant',
        label: <Link to="/web/corporate/gd-warrant">TRAVEL WARRANT</Link>
      },
    ]
  },
  {
    key: 'gd-domestic',
    label: <Link to="/web/posts/domestic"> Domestic </Link>
  },
  {
    key: 'ice-visa-services',
    label: <span>VISA <Icon path={mdiMenuDown} size="20px" /></span>,
    children: [
      {
        key: 'ice-visa-services-about-us',
        label: <Link to="/web/post/ice-visa-services"> About Us </Link>
      },
      {
        key: 'ice-visa-services-contact-agents',
        label: <Link to="/web/ice-visa-services-agents"> Contact Agents </Link>
      },
    ]
  },
  {
    key: 'media',
    label: <span>Media <Icon path={mdiMenuDown} size="20px" /></span>,
    children: [
      {
        key: 'media-news-and-blogs',
        label: <Link to="/web/blogs"> News </Link>
      },
      {
        key: 'media-whats-new',
        label: <Link to="/web/new-posts"> What's New </Link>
      },
      {
        key: 'media-gallery',
        label: <Link to="/web/gallery"> Gallery </Link>
      },
      {
        key: 'magazine-page',
        label: <Link to="/web/magazine"> Magazine </Link>
      }
    ]
  },
  {
    key: 'more',
    label: <span>More <Icon path={mdiMenuDown} size="20px" /></span>,
    children: [
      {
        key: 'more-about-us',
        label: <Link to="/web/about-us"> About Us </Link>
      },
      {
        key: 'more-contact-us',
        label: <Link to="/web/contact-us"> Contact Us </Link>
      },
      {
        key: 'more-contact-agents',
        label: <Link to="/web/contact-agents"> Contact Agents </Link>
      },
    ]
  }
];

const customExpandIcon = (props) => {
  if (props.isOpen) {
      return <a className="custom-expand-submenu-icon" onClick={e => {
          props.onExpand(props.record, e);
      }}><Icon path={mdiMenuUp} size={1} /></a>
  } else {
      return <a className="custom-expand-submenu-icon" onClick={e => {
          props.onExpand(props.record, e);
      }}><Icon path={mdiMenuDown} size={1} /></a>
  }
}

const Header: React.FC<{serverSideName: string, isPartner: boolean}> = ({serverSideName, isPartner}) => {
  const { username, logout, updateUsername, clearUser } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const activeUrlKey = location.pathname.split("/").pop() || "app";
  const [current, setCurrent] = useState(activeUrlKey);
  const truncateLength = 12;
  const displayUsername = isPartner ? serverSideName : username;

  useEffect(()=>{
    if(isPartner) {
      localStorage.removeItem('currentUser');
      return;
    }

    if(serverSideName) updateUsername(serverSideName);

  }, [serverSideName, isPartner])

  const partnerLogout = () => {
    UserApi.logout()
      .then(res => clearUser())
  }

  const getUserMenus = () => {
    const truncatedName = displayUsername && displayUsername.length > truncateLength
      ? displayUsername.substring(0, truncateLength) + "..."
      : (displayUsername || "");

    //remove this if partner already supports profile & bookings
    if(isPartner){
      return [
        {
          key: 'user',
          label: <span>hi, {truncatedName} <Icon path={mdiMenuDown} size="20px" /></span>
        },
        {
          key: 'logout',
          label: <span className="logout-icon" onClick={()=>partnerLogout()}><Icon title="Logout" path={mdiLogout} size="16px" /></span>
        }
      ]
    }

    return [
      {
        key: 'user',
        label: <span>hi, {truncatedName} <Icon path={mdiMenuDown} size="20px" /></span>,
        children:[
          {
            key: 'profile',
            label: <Link to="/web/profile">Profile</Link>
          },
          {
            key: 'bookings',
            label: <Link to="/web/bookings">Bookings</Link>
          }
        ]
      },
      {
        key: 'logout',
        label: <span className="logout-icon" onClick={()=>logout()}><Icon title="Logout" path={mdiLogout} size="16px" /></span>
      }
    ];
  }

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
  };

  return (
    <div className="header">
        <a href="/web" className="logo">
          <picture>
            <source media="(min-width: 769px)" srcSet="/iceholidays-assets/images/GD_logo.png" />
            <source media="(max-width: 768px)" srcSet="/iceholidays-assets/images/gd-logo_round.png" />
            <img src="/iceholidays-assets/images/GD_logo.png" alt="GD Logo" />
          </picture>
        </a>

        <div id="nav-buttons">
          <Menu mode="horizontal" items={items} onClick={onClick} selectedKeys={[current]} className="nav-menu"/>

          { displayUsername ?
            <Menu className="sign-out" items={getUserMenus()} mode="horizontal"/> : <Button href={SIGNIN_URL} className="sign-in"  type="primary"> sign in</Button>
          }

          <Button id="toggle-menu" type="primary" onClick={()=>setOpen(true)}>
            <Icon path={mdiMenu} size="25px" />
          </Button>
        </div>

      <Drawer title={null} onClose={()=>setOpen(false)} open={open} id="nav-drawer">
        <Menu items={items} mode="inline" expandIcon={(props) => customExpandIcon(props)} onClick={onClick} selectedKeys={[current]} className="nav-menu_mobile"/>
      </Drawer>
    </div>
  )


}

export default Header;
